<div class="row shipment-detail" *ngIf="!showTabs">
  <div class="col-lg-12">
    <p>No Record Found</p>
  </div>
</div>

<div class="shipment-detail" *ngIf="showTabs">
  <div class="row g-3">
    <div class="col-lg-6">
      <div class="info-card">
        <h3 class="info-card-title">Shipment Info</h3>
        <div class="info-row">
          <span class="info-row-label">Tracking Number</span>
          <span class="info-row-value link-value">{{
            trackingNumberDetail.trackingNumber
          }}</span>
        </div>
        <div class="info-row">
          <span class="info-row-label">Service</span>
          <span class="info-row-value">{{
            trackingNumberDetail.shippingMethod
          }}</span>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="info-card">
        <h3 class="info-card-title">Package Info</h3>
        <div class="info-row">
          <span class="info-row-label">Vendor-SKU</span>
          <span class="info-row-value">{{
            trackingNumberDetail.vendorSkuD365
          }}</span>
        </div>
        <div class="info-row">
          <span class="info-row-label">Quantity</span>
          <span class="info-row-value">{{
            trackingNumberDetail.quantityD365
          }}</span>
        </div>
        <div class="info-row" *ngFor="let item of trackingNumberDetail.weight">
          <span class="info-row-label">Weight</span>
          <span class="info-row-value">{{ item }}</span>
        </div>
        <div
          class="info-row"
          *ngFor="let item of trackingNumberDetail.dimension">
          <span class="info-row-label">Dimensions</span>
          <span class="info-row-value">{{ item }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row g-3 mt-1">
    <div class="col-lg-12">
      <div class="info-card">
        <h3 class="info-card-title">Route</h3>
        <div class="route-row">
          <div class="route-box">
            <span class="info-row-label">From</span>
            <p class="route-address">
              {{ trackingNumberDetail.shipperInformation }}
            </p>
          </div>
          <i class="pi pi-arrow-right route-arrow"></i>
          <div class="route-box">
            <span class="info-row-label">To</span>
            <p class="route-address">
              {{ trackingNumberDetail.recipientInformation }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-lg-12">
      <div
        class="status-banner"
        [class.in-transit]="
          trackingNumberDetail.deliveryStatus?.toLowerCase() === 'in transit'
        ">
        <span class="status-dot"></span>
        Current Status:
        <strong>{{ trackingNumberDetail.deliveryStatus }}</strong>
        <a class="status-banner-link" (click)="onViewTimeline()"
          >View Timeline</a
        >
      </div>
    </div>
  </div>
</div>

<div class="d-flex pt-3 justify-content-end gap-2">
  <p-button
    label="Back"
    (click)="onHide()"
    variant="outlined"
    severity="secondary" />
</div>

<!-- fixes/14757: original tab-based Tracking Details markup, replaced by the card/route/status-banner layout above
<!- - <div class="ms-3 nav-link p-0 d-flex align-items-center">
    <i class="icon-Copy me-2" (click)="onHide()"></i> -- >
<div class="row tracking-detail">
  <div class="col-lg-12 tracking-info-row">
    <div class="row g-4">
      <div class="col-auto">
        <p class="mb-0">
          <span class="info-label">Tracking Number:</span>
          <span class="font-weight-bold tracking-number-highlight">
            {{ trackingNumberDetail.trackingNumber }}</span
          >
        </p>
      </div>
      <div class="col-auto">
        <p class="mb-0">
          <span class="info-label">Method:</span>
          <span class="font-weight-bold">{{
            trackingNumberDetail.shippingMethod
          }}</span>
        </p>
      </div>
      <div class="col-auto">
        <p class="mb-0">
          <span class="info-label">Status:</span>
          <span class="font-weight-bold">{{
            trackingNumberDetail.deliveryStatus
          }}</span>
        </p>
      </div>
    </div>
  </div>
  <div class="col-lg-12" *ngIf="!showTabs">
    <p>No Record Found</p>
  </div>
  <div class="col-lg-12" *ngIf="showTabs">
    <p-tabView>
      <p-tabPanel header="Latest Status">
        <div class="row">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-4"><p>Status</p></div>
              <div class="col-lg-8 font-weight-bold">
                <p>{{ trackingNumberDetail.deliveryStatus }}</p>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4"><p>Address</p></div>
              <div class="col-lg-8 font-weight-bold">
                <p>{{ trackingNumberDetail.address ?? "" }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4"><p>Description</p></div>
              <div class="col-lg-8 font-weight-bold">
                <p>{{ trackingNumberDetail.description ?? "" }}</p>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-4"><p>Actual Date and Time</p></div>
              <div class="col-lg-8 font-weight-bold">
                <p>{{ trackingNumberDetail.actualDateTime ?? "" }}</p>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Package Details">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <h1 class="mb-4">Weight and Dimensions</h1>
              <div class="row">
                <div class="col-lg-4"><p>Weight</p></div>
                <div class="col-lg-8"><p>Dimensions</p></div>
              </div>
              <div class="row">
                <div class="col-lg-4 font-weight-bold">
                  <div *ngFor="let item of trackingNumberDetail.weight">
                    <p>{{ item }}</p>
                  </div>
                </div>
                <div class="col-lg-8 font-weight-bold">
                  <div *ngFor="let item of trackingNumberDetail.dimension">
                    <p>{{ item }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Shipper Information">
        <div class="row">
          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-12"><p>Shipper Information</p></div>
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-2"><p>Address:</p></div>
                  <div class="col-lg-10 font-weight-bold">
                    <p>{{ trackingNumberDetail.shipperInformation ?? "" }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="row">
              <div class="col-lg-12"><p>Recipient Information</p></div>
              <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-2"><p>Address:</p></div>
                  <div class="col-lg-10 font-weight-bold">
                    <p>{{ trackingNumberDetail.recipientInformation ?? "" }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>
<ng-template pTemplate="footer"> </ng-template>
<!- - </div> -- >
-->
